import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quickpay-settings" }

import { ref, inject, onMounted, onBeforeUnmount } from 'vue';
import { Translator, PushToast } from 'js/shims-vue';
import QuickpaySettingsPitch from 'vcomponents/quickpay/settings/QuickpaySettingsPitch.vue';
import QuickpaySettingsPaymentPartners from 'vcomponents/quickpay/settings/QuickpaySettingsPaymentPartners.vue';
import QuickpaySettingsBlockPreferences from 'vcomponents/quickpay/settings/QuickpaySettingsBlockPreferences.vue';
import { fetchPaymentProviders } from 'api/quickpay/quickpayService';
import QuickpaySettingsRightSidebar from 'vcomponents/quickpay/settings/QuickpaySettingsRightSidebar.vue';
import LayoutSettings2Cols from 'vcomponents/common/layout/content/LayoutSettings2Cols.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickpaySettings',
  setup(__props) {

const $t = inject('$t') as Translator;
const $pushToast = inject('$pushToast') as PushToast;

const providerStatuses = ref<Record<string, string>>({});
const isLoading = ref(true);

const loadProviders = async (): Promise<void> => {
    try {
        const response = await fetchPaymentProviders();
        const data = response.data as { data: { name: string; status: string }[] };
        const statusMap: Record<string, string> = {};
        // API provider.name must match dictionary provider.id (ex: 'stripe', 'gocardless')
        for (const provider of data.data) {
            statusMap[provider.name] = provider.status;
        }
        providerStatuses.value = statusMap;
    } catch {
        $pushToast({
            type: 'error',
            icon: true,
            text: $t.__('common.labels.toast.error'),
        });
    } finally {
        isLoading.value = false;
    }
};

onMounted(() => {
    loadProviders();
    EventBus.on('stancer:settings:saved', loadProviders);
});

onBeforeUnmount(() => {
    EventBus.off('stancer:settings:saved', loadProviders);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LayoutSettings2Cols, null, {
      content: _withCtx(() => [
        _createVNode(QuickpaySettingsPitch),
        _createVNode(QuickpaySettingsPaymentPartners, {
          providerStatuses: providerStatuses.value,
          isLoading: isLoading.value
        }, null, 8 /* PROPS */, ["providerStatuses", "isLoading"]),
        _createVNode(QuickpaySettingsBlockPreferences, {
          providerStatuses: providerStatuses.value,
          isLoadingProviders: isLoading.value
        }, null, 8 /* PROPS */, ["providerStatuses", "isLoadingProviders"])
      ]),
      "sidebar-right": _withCtx(() => [
        _createVNode(QuickpaySettingsRightSidebar)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})